// Import: Middleware Action & Custom Types
import {
  CLEAN_ZIPCODE_ADDRESS_STORE,
  CLEAN_ZIPCODE_ADDRESS_STORE_ERROR,
} from '_models/redux/types';

// Action function
export const cleanZipCodeAddressStore = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_ZIPCODE_ADDRESS_STORE,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_ZIPCODE_ADDRESS_STORE_ERROR,
      payload: undefined,
    });
  }
};
